// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { EarthquakeProtectionStatus } from './earthquake-protection-status';


export class EarthquakeProtectionMessage implements flatbuffers.IUnpackableObject<EarthquakeProtectionMessageT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):EarthquakeProtectionMessage {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsEarthquakeProtectionMessage(bb:flatbuffers.ByteBuffer, obj?:EarthquakeProtectionMessage):EarthquakeProtectionMessage {
  return (obj || new EarthquakeProtectionMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsEarthquakeProtectionMessage(bb:flatbuffers.ByteBuffer, obj?:EarthquakeProtectionMessage):EarthquakeProtectionMessage {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new EarthquakeProtectionMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

message():EarthquakeProtectionStatus {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : EarthquakeProtectionStatus.Normal;
}

static startEarthquakeProtectionMessage(builder:flatbuffers.Builder) {
  builder.startObject(1);
}

static addMessage(builder:flatbuffers.Builder, message:EarthquakeProtectionStatus) {
  builder.addFieldInt16(0, message, EarthquakeProtectionStatus.Normal);
}

static endEarthquakeProtectionMessage(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createEarthquakeProtectionMessage(builder:flatbuffers.Builder, message:EarthquakeProtectionStatus):flatbuffers.Offset {
  EarthquakeProtectionMessage.startEarthquakeProtectionMessage(builder);
  EarthquakeProtectionMessage.addMessage(builder, message);
  return EarthquakeProtectionMessage.endEarthquakeProtectionMessage(builder);
}

unpack(): EarthquakeProtectionMessageT {
  return new EarthquakeProtectionMessageT(
    this.message()
  );
}


unpackTo(_o: EarthquakeProtectionMessageT): void {
  _o.message = this.message();
}
}

export class EarthquakeProtectionMessageT implements flatbuffers.IGeneratedObject {
constructor(
  public message: EarthquakeProtectionStatus = EarthquakeProtectionStatus.Normal
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  return EarthquakeProtectionMessage.createEarthquakeProtectionMessage(builder,
    this.message
  );
}
}
